import { useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { NavigationToggle } from './NavigationToggle';
import { NavigationItems } from './NavigationItems';
import { useIsMobileView } from '../hooks/useWindowSize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Navigation = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const isMobileView = useIsMobileView();
  if (isMobileView) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    backgroundColor: "fill-surface-default",
    borderInlineEndStyle: "solid",
    borderInlineEndColor: "border-transitional-core-subtle",
    borderInlineEndWidth: "100",
    justifyContent: "space-between",
    paddingBlock: "400",
    paddingInline: "300",
    children: [/*#__PURE__*/_jsx(NavigationItems, {
      isExpanded: isExpanded
    }), /*#__PURE__*/_jsx(NavigationToggle, {
      isExpanded: isExpanded,
      toggleVisibility: () => setIsExpanded(prev => !prev)
    })]
  });
};